import React from 'react';
import { Box, Typography } from '@mui/material';
import PublisherLogo from '../../components/publisherLogo';

const card = {
    background: 'linear-gradient(180deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.015) 100%)',
    border: '1px solid rgba(187,188,188,0.14)',
    borderRadius: '22px',
    padding: '20px',
    mt: 2,
};

const item = {
    display: 'flex',
    alignItems: 'center',
    gap: 1.25,
};

const manageBtn = {
    fontSize: '12px',
    color: 'var(--ecal-lightblue)',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    flexShrink: 0,
    fontFamily: 'inherit',
    '&:hover': { textDecoration: 'underline' },
};

function QuickView({ items = [], onManage }) {
    function renderItem(sub) {
        return (
            <Box key={sub.id} sx={item}>
                <PublisherLogo logo={sub.logo} name={sub.name} size={32} borderRadius="6px" />
                <Box sx={{ minWidth: 0, flex: 1 }}>
                    <Typography sx={{ fontSize: '0.875rem', fontWeight: 500, color: 'var(--ecal-white)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {sub.name}
                    </Typography>
                    <Typography sx={{ fontSize: '0.6875rem', color: 'var(--ecal-lightgrey)' }}>
                        {sub.scheduleCount} schedule{sub.scheduleCount !== 1 ? 's' : ''}
                    </Typography>
                </Box>
                <Box component="button" onClick={onManage} sx={manageBtn}>
                    Manage
                </Box>
            </Box>
        );
    }

    return (
        <Box sx={card}>
            <Typography sx={{ fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.6px', color: 'var(--ecal-lightgrey)', mb: 1.5 }}>
                Quick view · Active subscriptions
            </Typography>
            {items.length === 0 ? (
                <Typography sx={{ fontSize: '0.72rem', color: 'var(--ecal-midgrey)' }}>
                    No active subscriptions yet.
                </Typography>
            ) : (
                items.map(renderItem)
            )}
        </Box>
    );
}

export default QuickView;
